"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CheckedItem;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/styles");
const clsx_1 = __importDefault(require("clsx"));
const Text_1 = __importDefault(require("../Text"));
const variables_1 = __importDefault(require("../../styles/variables"));
const Icon_1 = require("../Icon");
const useStyles = (0, styles_1.makeStyles)({
    wrapper: {
        display: 'flex',
    },
    checkIcon: {
        marginRight: variables_1.default.spacing(2),
        marginTop: variables_1.default.spacing(0.4),
        color: variables_1.default.colors.icon.success,
    },
    title: { color: variables_1.default.colors.text.info },
    details: { color: variables_1.default.colors.text.default },
    checkItem: { fontWeight: variables_1.default.fonts.weight.medium },
});
function CheckedItem({ header, details, className, ...rest }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(className, classes.wrapper), ...rest },
        react_1.default.createElement(Icon_1.RegularIcon, { icon: "check_circle", className: classes.checkIcon }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(Text_1.default, { as: "h5", "data-testid": `title${header}`, className: (0, clsx_1.default)(classes.checkItem, classes.title) }, header),
            react_1.default.createElement(Text_1.default, { className: (0, clsx_1.default)(classes.checkItem, classes.details), as: "h5" }, details))));
}
